import { render, staticRenderFns } from "./CellDropdownActions.vue?vue&type=template&id=5ca64bef&scoped=true"
import script from "./CellDropdownActions.vue?vue&type=script&lang=js"
export * from "./CellDropdownActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca64bef",
  null
  
)

export default component.exports